import React from "react";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => (
  <Button
    type="link"
    icon={<ArrowLeftOutlined />}
    onClick={onClick}
    className="text-[#0C4A6E]! font-semibold flex items-center p-0"
  >
    Go back
  </Button>
);

export default BackButton;
